document.addEventListener("DOMContentLoaded", function() {
  function customEncode(value) {
    return btoa(
      encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, function(e, t) {
        return String.fromCharCode("0x" + t);
      })
    );
  }

  let checkInsider = setInterval(function() {
    if (typeof insider_object !== "undefined") {
      try {
        // PRODUCT OBJECT
        let product_item = insider_object.product
        if (product_item) {
          if (product_item?.custom?.product_id) {
            product_item.custom.product_id = customEncode(
              product_item.custom.product_id
            );
          }

          if (product_item?.id) {
            product_item.id = customEncode(
              product_item.id
            );
          }
  
          if (product_item?.groupcode) {
            product_item.groupcode = customEncode(
              product_item.groupcode
            );
          }
        }

        // BASKET OBJECT
        if (Array.isArray(insider_object.basket?.line_items)) {
          insider_object.basket.line_items.forEach((item) => {
            let basket_item = item.product
            if (basket_item) {
              if (basket_item.custom?.product_id) {
                basket_item.custom.product_id = customEncode(
                  basket_item.custom.product_id
                );
              }
              
              if (basket_item.id) {
                basket_item.id = customEncode(
                  basket_item.id
                );
              }
            }
          });
        }

        clearInterval(checkInsider);
      } catch (e) {
        console.warn("No se pudo encodear los valores de insider_object:", e);
      }
    }
  }, 500);
});